import React from 'react';
import utils from '@/common/utils';
import ComponentLog from '@/components/component-log';
import { Tooltip } from 'antd';

const SignupList = (props) => {
  const { btnText = '', signupList = [], source = '', toSignup = () => {}, clstag = '', type = '' } = props;
  return (
    <div className="myTodoList">
      {signupList.map((item, index) => (
        <div key={index} className="MyTodoList-item">
          {item.activityName ? (
            <>
              {type === 'channel' ? (
                <div className="areaName-wrap">
                  <Tooltip placement="topLeft" title={item.resourceName}>
                    <div className="areaName-wrap-text">{item.resourceName}</div>
                  </Tooltip>
                  <div className="text">资源位ID:{item.resourceId}</div>
                </div>
              ) : (
                <div className="areaName-wrap">
                  <Tooltip placement="topLeft" title={item.activityName}>
                    <div className="areaName-wrap-text">{item.activityName}</div>
                  </Tooltip>
                  <div className="text">活动ID:{item.activityId}</div>
                </div>
              )}
              {source === 1 ? (
                <>
                  <div className="collect-pool-wrap">
                    <div className="name">收品池名称</div>
                    <Tooltip placement="topLeft" title={item.areaName}>
                      <div className="text">{item.areaName}</div>
                    </Tooltip>
                  </div>
                  <div className="session-startTime-wrap">
                    <div className="name">场次时间</div>
                    <Tooltip
                      placement="topLeft"
                      title={`${utils.enhancedFormateTimeStamp(item.beginTime)} 至 ${
                        item.endTime ? utils.enhancedFormateTimeStamp(item.endTime) : '--'
                      }`}
                    >
                      <div className="text">
                        {utils.enhancedFormateTimeStamp(item.beginTime)} 至{' '}
                        {item.endTime ? utils.enhancedFormateTimeStamp(item.endTime) : '--'}
                      </div>
                    </Tooltip>
                  </div>
                </>
              ) : null}
              {source === 2 ? (
                <div className="session-signup-endTime-wrap">
                  <div className="name">活动报名时间</div>
                  <div className="text">
                    {utils.enhancedFormateTimeStamp(item.applyBeginTime)} 至{' '}
                    {utils.enhancedFormateTimeStamp(item.applyEndTime)}
                  </div>
                </div>
              ) : null}
              <div className="deadline-wrap">
                <div className="name">报名剩余时长{utils.remainingHoursAndMin(item.cutOffTime)}</div>
              </div>
              <div className="goCheck-wrap">
                <ComponentLog>
                  <div clstag={clstag} className="name" onClick={() => toSignup(item)}>
                    {btnText}
                  </div>
                </ComponentLog>
              </div>
            </>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default SignupList;
